import React from 'react';
import { Heart, ShieldCheck, Sparkles, MapPin, CheckCircle2 } from 'lucide-react';
import { aboutPageExtras } from '../mock';
import { VALUE_ICON_SIZE, EXPERTISE_CHECK_ICON_SIZE } from '../constants/icon-sizes';

const valueIcons = [Heart, Sparkles, ShieldCheck, MapPin];

const StorySection = () => (
  <section className="py-24 bg-slate-50">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-12">
        <span className="inline-block text-blue-600 font-semibold text-sm uppercase tracking-wider mb-3">
          Our Story
        </span>
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900">
          How AA Plumbing & Roofing <span className="text-red-600">Came to Be</span>
        </h2>
      </div>
      <div className="space-y-5 text-lg text-slate-700 leading-relaxed">
        {aboutPageExtras.story.paragraphs.map((p) => (
          <p key={p.slice(0, 40)}>{p}</p>
        ))}
      </div>
    </div>
  </section>
);

const ValueCard = ({ value, idx }) => {
  const Icon = valueIcons[idx];
  return (
    <div
      data-testid={`about-value-${idx}`}
      className="bg-slate-50 rounded-xl p-7 border border-slate-200 hover:border-blue-200 hover:shadow-md transition-all duration-300"
    >
      <div className="bg-blue-600 w-14 h-14 rounded-xl flex items-center justify-center mb-5 shadow-md">
        <Icon className="text-white" size={VALUE_ICON_SIZE} />
      </div>
      <h3 className="text-xl font-bold text-slate-900 mb-3">{value.title}</h3>
      <p className="text-slate-600 leading-relaxed">{value.description}</p>
    </div>
  );
};

const ValuesSection = () => (
  <section className="py-24 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-14">
        <span className="inline-block text-blue-600 font-semibold text-sm uppercase tracking-wider mb-3">
          What We Stand For
        </span>
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900">
          Our <span className="text-red-600">Values</span>
        </h2>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
        {aboutPageExtras.values.map((value, idx) => (
          <ValueCard key={value.title} value={value} idx={idx} />
        ))}
      </div>
    </div>
  </section>
);

const ExpertiseSection = () => {
  const titleParts = aboutPageExtras.expertise.title.split(' ');
  return (
    <section className="py-24 bg-slate-50">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="inline-block text-blue-600 font-semibold text-sm uppercase tracking-wider mb-3">
            Skills & Trades
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900">
            {titleParts.slice(0, -1).join(' ')}{' '}
            <span className="text-red-600">{titleParts.slice(-1)}</span>
          </h2>
        </div>
        <div className="grid md:grid-cols-2 gap-4">
          {aboutPageExtras.expertise.items.map((item, idx) => (
            <div
              key={item}
              data-testid={`about-expertise-${idx}`}
              className="flex items-start gap-3 bg-white rounded-xl p-5 border border-slate-200 hover:border-blue-200 transition-colors duration-300"
            >
              <CheckCircle2 className="text-blue-600 flex-shrink-0 mt-0.5" size={EXPERTISE_CHECK_ICON_SIZE} />
              <span className="text-slate-700 leading-relaxed">{item}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const AboutDeepDive = () => (
  <>
    <StorySection />
    <ValuesSection />
    <ExpertiseSection />
  </>
);

export default AboutDeepDive;
